module.exports = __webpack_public_path__ + "img/img_hc_big.da3a0ba4.png";